export const contentTableConfig = {
  title: '访问记录',
  propList: [
    {
      prop: 'consumerNickName',
      label: '客户昵称',
      minWidth: '80',
      slotName: 'consumer',
      align: 'left'
    },
    {
      prop: 'title',
      label: '看过的素材',
      minWidth: '120',
      slotName: 'material',
      sortable: 'custom'
    },
    { prop: 'deptName', label: '所属部门', minWidth: '80' },
    {
      prop: 'empName',
      label: '所属员工',
      minWidth: '80'
    },
    {
      prop: 'accessTime',
      label: '访问时间',
      minWidth: '120',
      slotName: 'accessTime',
      sortable: true
    },
    {
      prop: 'duration',
      label: '访问时长',
      minWidth: '120',
      slotName: 'duration',
      sortable: 'custom'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
